import React from "react";
import { Text, View, StyleSheet, Image } from "react-native";

import t from "@constants/localization";
import colors from "@constants/color";
import NoRto from "@assets/images/NoRto.png";
import NoDelivery from "@assets/images/NoDelivery.png";
import NoOrders from "@assets/svg/RRD/NoOrders";
import NoPending from "@assets/images/NoPending.png";

function EmptyList({ type, searchTerm }) {
  const PATH = "screens/MyTask";
  const getEmptyTitle = () => {
    if (searchTerm && searchTerm.length > 0) {
      return t(`SearchOrder/noResultFoundText`);
    }
    if (type === "pending") {
      return t(`${PATH}/no_pending_orders`);
    }
    if (type === "delivery") {
      return t(`${PATH}/no_delivered_orders`);
    }
    if (type === "rescheduled") {
      return t(`${PATH}/no_rescheduled_orders`);
    }
    return t(`${PATH}/no_rto_orders`);
  };

  const getEmptySubTitle = () => {
    if (searchTerm && searchTerm.length > 0) {
      return t(`SearchOrder/noResultFoundSubText`);
    }
    if (type === "pending") {
      return t(`${PATH}/no_pending_orders_subtitle`);
    }
    if (type === "delivery") {
      return t(`${PATH}/no_delivered_orders_subtitle`);
    }
    if (type === "rescheduled") {
      return t(`${PATH}/no_rescheduled_orders_subtitle`);
    }
    return t(`${PATH}/no_rto_orders_subtitle`);
  };

  const getEmptyIcon = () => {
    if (searchTerm && searchTerm.length > 0) {
      return <NoOrders />;
    }
    if (type === "pending") {
      return <Image source={NoPending} />;
    }
    if (type === "delivery") {
      return <Image source={NoDelivery} />;
    }
    return <Image source={NoRto} />;
  };

  return (
    <View style={styles.loadingView}>
      <View style={styles.emptyView}>
        {getEmptyIcon()}
        <Text style={styles.emptyText1}>{getEmptyTitle()}</Text>
        <Text style={styles.emptyText2}>{getEmptySubTitle()}</Text>
        <View style={{ height: 50 }} />
      </View>
    </View>
  );
}
const styles = StyleSheet.create({
  loadingView: {
    justifyContent: "center",
    alignItems: "center",
    flex: 1,
    backgroundColor: colors.white,
  },
  emptyView: {
    alignItems: "center",
    justifyContent: "center",
    flex: 1,
  },
  emptyText1: {
    fontSize: 18,
    lineHeight: 27,
    color: colors.mediumBlack,
    marginTop: 16,
    fontWeight: "600",
  },
  emptyText2: {
    fontSize: 14,
    lineHeight: 20,
    color: colors.mediumBlacklightBlack,
    marginTop: 8,
    fontWeight: "400",
    justifyContent: "center",
    textAlign: "center",
  },
});

export default EmptyList;
